import HighOrderApp from "./high_order_app";

function App() {
  return <HighOrderApp />;
}

export default App;
